// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"4ed95f74","161":"decd75ee","205":"aebf3b99","339":"5b27b966","393":"9abe38c4","427":"f4a54765","456":"f450659b","514":"bc6591a0","529":"c9b71d5d","605":"6fccc604","614":"9426eedd","637":"632166d9","662":"2696a91f","747":"321d4b3f","976":"2c92362b"}[chunkId] + ".chunk.js";
};